import uuid from 'uuid/v1';

export default [
  {
    id: uuid(),
    supervisor: 'دفتر فنی انتقال',
  },
  {
    id: uuid(),
    supervisor: 'امور انتقال نیرو',
  },
  {
    id: uuid(),
    supervisor: 'دیسپاچینگ',
  },
  {
    id: uuid(),
    supervisor: 'HSE',
  },
  
  
];
